/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateStatus } from '../enums/candidate-status';
import { CandidateEntity } from './candidate-entity';
import { OpportunityEntity } from './opportunity-entity';
import { UserEntity } from './user-entity';
export class CandidatesOpportunitiesStatusHistoryEntity extends Entity {
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  candidateStatus: CandidateStatus | null = null;
  candidateStatusUpdatedAt: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  opportunity: OpportunityEntity | null = null;
  opportunityId: string | null = null;
  previousCandidateStatus: string | null = null;
  previousPositiveCandidateStatus: string | null = null;
  updatedAt: string | null = null;
  updatedBy: string | null = null;
  updatedByUser: UserEntity | null = null;
  static override key = 'CandidatesOpportunitiesStatusHistory';
  static override get schema() {
    return {
      candidate: CandidateEntity,
      opportunity: OpportunityEntity,
      updatedByUser: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidatesOpportunitiesStatusHistory' in input
    ) {
      const { CandidatesOpportunitiesStatusHistory: wrapped, ...rest } = input as {
        CandidatesOpportunitiesStatusHistory: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}